function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "prefix__a",
  width: 512,
  height: 512,
  x: 0,
  y: 0,
  rx: "15%",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "prefix__b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#prefix__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#35a85b",
  d: "M0 512V0h512z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5881ca",
  d: "M256 288L32 512h448z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c1c0be",
  d: "M288 256L512 32v448z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#fadb2a",
  strokeWidth: 71,
  d: "M0 512L512 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#f2f2f2",
  strokeWidth: 22,
  d: "M175 173h50a50 54 0 11-15-41"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#de3738",
  d: "M353 85a70 70 0 01140 0c0 70-70 70-70 157 0-87-70-87-70-157"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 423,
  cy: 89,
  r: 25,
  fill: "#7d2426"
}));

function SvgMapsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "Google Maps",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsIcon);
export default __webpack_public_path__ + "static/media/maps-icon.76d304ec06273e668ff3da9fcdb9e5f0.svg";
export { ForwardRef as ReactComponent };